import { Autocomplete, IconButton, TextField, Tooltip } from '@mui/material'
import React, { useEffect } from 'react'
import colorListSlice from '../../../../../Redux/Product Master/colorListSlice'
import { useNavigate } from 'react-router-dom'
import { editBranchSettingsUserAPICall, viewBranchSettingsAPICall, viewBranchSettingsUserAPICall } from '../../../Settings/BranchSettings/branchSettingsAPI'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { vieWareHouseLocationAPICall } from '../../../Inventory/Configuration/wareHouseLocationAPI'
import { filterObjFromList } from '../../../../../Js/generalFunctions'
import { journalListApiCall } from '../../../../../API/AccountUpdated/journalAPI'
import { getAllTaxSettingsListAPICall } from '../../../../../API/Settings/TaxSettings/taxSettingsAPI'
import SuccessSnackbar from '../../../../Single Components/SnackBars/SuccessSnackbar'
import ErrorSnackbar from '../../../../Single Components/SnackBars/ErrorSnackbar'
import { getPriceListApi } from '../../../SalesNew/SalesOrders/priceList/priceListAPI'
import { branchSettingsSingleView } from './BranchSettingsAPI'
import { viewAllAllowedBranchesAPICall, viewAllBranchesAPICall } from '../../../../../API/Settings/Company Settings/companySettingsAPI'
import PosBranchConfigurations from './PosBranchConfigurations'
import { categoryListAPICall } from '../../../Inventory/Configuration/Category/CategoryAPI'
import LinkDeviceForm from './whatsappComponents/LinkDeviceForm'
import QrCodeDisplay from './whatsappComponents/QrCodeDisplay'
import SendMessageForm from './whatsappComponents/SendMessageForm'


export const BranchSettingsForm = () => {
   let navigate=useNavigate()
   
   const branchSettingsView = useSelector(
    (state) => state.branchSettingsSliceNew.rowData
  );
  if (branchSettingsView) console.log(branchSettingsView,'branchSettingsView')
   const {branchPosConfigurations} = useSelector(
    (state) => state.branchSettingsSliceNew
  );
  const singleRowId=localStorage.getItem("singleViewById")

  const journalList = useSelector((state) => state.journalSlice.value)

   // login response
   const loginResponse = useSelector((state) => state.loginResponseSlice.value);
   const allBranchesList = useSelector((state) => state.allBranchesSlice.value);


  const wareHouseLocationList=useSelector((state)=>state.wareHouseLocationSlice.value)
  const typeCashJournalList=journalList?.filter(item=>item.type === "cash")
  const typeBankJournalList=journalList?.filter(item=>item.type ==="bank")
  const allTaxList = useSelector((state) => state.taxSettingsSlice.value);
  const allTaxListTypeSales = allTaxList?.filter((obj)=>obj?.taxType==="Sales")

  const locTypeInternal=wareHouseLocationList?.filter(item=>item?.locationType==="INTERNAL")
  const priceListData = useSelector((state) => state.priceListSlice?.priceListData);
  const types=[
    {value:"card"},
    {value:"cash"},
    {value:"upi"},
    {value:"cheque"},
  ]
  const posMachineProviders=[
    {value:"pinelab", label:"Pine Labs"},
    {value:"paytm", label:"Paytm"},
    {value:"other", label:"Other"},
  ]
  const [sequenseTable,setSequenceTable]=useState([])
  const [formValues,setFormValues]=useState({
      branch:null,
      location:null,
      priceList:null,
      defaultTax:[],
      type:null,
      journal:null,
      upiProvider:null,
      upiId:"",
      bankingName:"",
      upiApiEnabled:false,
      upiApiConfig:{
        merchantId:"",
        apiKey:"",
        apiSecret:"",
        apiUrl:""
      },
      posMachineEnabled:false,
      posMachineProvider:null,
      posMachineConfig:{
        merchantId:"",
        terminalId:"",
        apiKey:"",
        apiSecret:"",
        apiUrl:""
      },
      termsAndCondition:""
  })
  const [paymentTypeTable,setPaymentTypeTable]=useState([])
  const [snackBarStates, setSnackBarStates] = useState({
    success: false,
    error: false,
    message: "",
  });
  const [validationAlert,setValidationAlert]=useState({})
  const [whatsAppConfig, setWhatsAppConfig] = useState(null);
  const [whatsappEnable, setWhatsappEnable] = useState(false);
  const [taxFilteredList,setTaxFileteredList]=useState(allTaxList)
    //closeSnackbar
    const closeSnackbar = () => {
      setSnackBarStates({
        ...snackBarStates,
        success: false,
        error: false,
        message: "",
      });
    };

  const backButtonFn=()=>{
    
    navigate("/userdashboard/pointOfSales/configuration/BranchSettings")
  }

 




  const plusButtonFn=()=>{
    if(formValues?.type===null){
      setValidationAlert({...validationAlert,type:"Select Type"})
    }
    else if(formValues?.journal===null){
      setValidationAlert({...validationAlert,journal:"Select Journal"})
    }
    else{

      const journalId = formValues?.journal?._id;
      // Check if the attributeId already exists in the attributeTable
      const isJournalIdExist = paymentTypeTable.some(item => item.journalId === journalId);
      if(isJournalIdExist){
        setSnackBarStates({ ...snackBarStates, message: "journal " + formValues?.journal?.journalName + " already added !!", error: true })
      }
      else{

        setPaymentTypeTable([...paymentTypeTable,
          {
            type:formValues?.type?.value,
            journalName:formValues?.journal?.journalName,
            journalId:formValues?.journal?._id,
            upiProvider:formValues?.type?.value==="upi"?(formValues?.upiProvider?.value || null):null,
            upiProviderName:formValues?.type?.value==="upi"?(formValues?.upiProvider?.label || null):null,
            upiId:formValues?.type?.value==="upi"?(formValues?.upiId || null):null,
            bankingName:formValues?.type?.value==="upi"?(formValues?.bankingName || null):null,
            upiApiEnabled:formValues?.type?.value==="upi"?(formValues?.upiApiEnabled || false):false,
            upiApiConfig:formValues?.type?.value==="upi" && formValues?.upiApiEnabled?formValues?.upiApiConfig:null,
            posMachineEnabled:formValues?.type?.value==="card"?(formValues?.posMachineEnabled || false):false,
            posMachineProvider:formValues?.type?.value==="card" && formValues?.posMachineEnabled?(formValues?.posMachineProvider?.value || null):null,
            posMachineConfig:formValues?.type?.value==="card" && formValues?.posMachineEnabled?formValues?.posMachineConfig:null
          }
        ])
        setFormValues({...formValues,type:null,journal:null,upiProvider:null,upiId:"",bankingName:"",upiApiEnabled:false,upiApiConfig:{merchantId:"",apiKey:"",apiSecret:"",apiUrl:""},posMachineEnabled:false,posMachineProvider:null,posMachineConfig:{merchantId:"",terminalId:"",apiKey:"",apiSecret:"",apiUrl:""}})
      }
    }
   
  }
  const upiProviders = [
    { value: "gpay", label: "Google Pay" },
    { value: "paytm", label: "Paytm" },
    { value: "phonepe", label: "PhonePe" },
    { value: "bhim", label: "BHIM" },
    { value: "other", label: "Other" },
  ];
  const tableSingleEdit=(data,index)=>()=>{
  paymentTypeTable?.splice(index,1)
   setFormValues({
    ...formValues,
    type:filterObjFromList("value",types,"type",data),
    journal:filterObjFromList("_id",journalList,"journalId",data),
    upiProvider:data?.type==="upi" && data?.upiProvider?upiProviders.find(p => p.value === data.upiProvider):null,
    upiId:data?.type==="upi"?(data?.upiId || ""):"",
    bankingName:data?.type==="upi"?(data?.bankingName || ""):"",
    upiApiEnabled:data?.type==="upi"?(data?.upiApiEnabled || false):false,
    upiApiConfig:data?.type==="upi" && data?.upiApiConfig?data?.upiApiConfig:{merchantId:"",apiKey:"",apiSecret:"",apiUrl:""},
    posMachineEnabled:data?.type==="card"?(data?.posMachineEnabled || false):false,
    posMachineProvider:data?.type==="card" && data?.posMachineProvider?filterObjFromList("value",posMachineProviders,"posMachineProvider",{posMachineProvider:data?.posMachineProvider}):null,
    posMachineConfig:data?.type==="card" && data?.posMachineConfig?data?.posMachineConfig:{merchantId:"",terminalId:"",apiKey:"",apiSecret:"",apiUrl:""}
   })
  }

  

 
  const sequenceChange=(index,key)=>(e)=>{
    if (key==="prefix") {
      sequenseTable[index].prefix=e.target.value
    }
    if(key==="sequenceSize"){
      sequenseTable[index].sequenceSize=Number(e.target.value)||""
    }
    if(key==="nextNumber"){
      sequenseTable[index].nextNumber=Number(e.target.value)||""
    }
 
   
  }
  const bodyToApi={
    _id:branchSettingsView?._id,
    branchId:formValues?.branch?._id,
    locationId:formValues?.location?._id,
    priceList:formValues?.priceList?._id,
    termsAndCondition:formValues?.termsAndCondition,
    defaultTax:formValues?.defaultTax,
    paymentTypes:paymentTypeTable,
    sequences:sequenseTable,
    enableKot:branchPosConfigurations?.enableKot,
    updateOrdAuth:branchPosConfigurations?.updateOrdAuth,
    updateOrdAuthEmployees: branchPosConfigurations?.updateOrdAuthEmployees?.map((emp) => ({ employeeId: emp?._id, name: emp?.staff_name })) || [],
    cancelOrdAuth:branchPosConfigurations?.cancelOrdAuth,
    cancelOrdAuthEmployees: branchPosConfigurations?.cancelOrdAuthEmployees?.map((emp) => ({ employeeId: emp?._id, name: emp?.staff_name })) || [],
    addDiscountAuth:branchPosConfigurations?.addDiscountAuth,
    addDiscountAuthEmployees: branchPosConfigurations?.addDiscountAuthEmployees?.map((emp) => ({ employeeId: emp?._id, name: emp?.staff_name })) || [],
    enableMultipleOrder:branchPosConfigurations?.enableMultipleOrder,
    deliveryCharge:branchPosConfigurations?.deliveryCharge,
    deliveryAmt: Number(branchPosConfigurations?.deliveryAmt),
    deliveryChargeMode: branchPosConfigurations?.deliveryChargeMode || "flat",
    perKmCharge: branchPosConfigurations?.perKmCharge === "" ? undefined : Number(branchPosConfigurations?.perKmCharge),
    freeDeliveryAbove: branchPosConfigurations?.freeDeliveryAbove === "" ? undefined : Number(branchPosConfigurations?.freeDeliveryAbove),
    kmRangeRules: Array.isArray(branchPosConfigurations?.kmRangeRules) ? branchPosConfigurations?.kmRangeRules : [],
    deliveryChargeAggregatorId: branchPosConfigurations?.deliveryChargeAggregators?.map((item) => ({aggregatorId: item?._id})) || [],
    packagingCharge: branchPosConfigurations?.packageCharge,
    openingBalFromInvenrory: branchPosConfigurations?.openingBalFromInvenrory,
    iaPhysicalClosingManual: branchPosConfigurations?.iaPhysicalClosingManual || false,
    pkgCharge: Number(branchPosConfigurations?.packageAmt),
    printCount: branchPosConfigurations?.printCount || 1,
    noDecreasePrice: !!branchPosConfigurations?.noDecreasePrice,
    enablePosDevices: !!branchPosConfigurations?.enablePosDevices,
    posDevices:
      branchPosConfigurations?.enablePosDevices && Array.isArray(branchPosConfigurations?.posDevices)
        ? branchPosConfigurations.posDevices.map((device) => ({
            deviceName: device?.name,
            employees: Array.isArray(device?.employees)
              ? device.employees.map((emp) => ({ empId: emp?._id }))
              : [],
            categories: Array.isArray(device?.categories)
              ? device.categories.map((cat) => ({ catId: cat?._id }))
              : [],
            specialPosCategory: device?.allowSpecialItems || false,
            acceptExternalOrders: device?.allowExternalOrders || false,
          }))
        : [],
    autoRecipe:branchPosConfigurations?.recipeAuto,
    // ...(whatsAppConfig ? whatsAppConfig : {})
     enableWhatsApp: whatsappEnable,
    ...(whatsappEnable && whatsAppConfig
        ? {
            whatsAppBilling: whatsAppConfig.whatsAppBilling,
            whatsAppShiftReport: whatsAppConfig.whatsAppShiftReport,
            whatsAppMessageDelivery: whatsAppConfig.whatsAppMessageDelivery,
        }
        : {
            whatsAppBilling: undefined,
            whatsAppShiftReport: undefined,
            whatsAppMessageDelivery: undefined,
        }),
  }
  const branchSettingsEditFunction=()=>{
    try {
      // Temporary fallback: persist noDecreasePrice locally so UI can restore if backend doesn't return it yet
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('branchSettings.noDecreasePrice', JSON.stringify(!!branchPosConfigurations?.noDecreasePrice));
      }
    } catch (e) {}
    console.log('💾 Saving branch settings...', { 
      deliveryChargeMode: bodyToApi?.deliveryChargeMode,
      deliveryCharge: bodyToApi?.deliveryCharge,
      deliveryChargeAggregatorId: bodyToApi?.deliveryChargeAggregatorId,
      branchPosConfigurations_deliveryChargeAggregators: branchPosConfigurations?.deliveryChargeAggregators,
      iaPhysicalClosingManual: bodyToApi?.iaPhysicalClosingManual
    });
    console.log('🔐 Employee Auth Data:', {
      updateOrdAuth: bodyToApi?.updateOrdAuth,
      updateOrdAuthEmployees: bodyToApi?.updateOrdAuthEmployees,
      cancelOrdAuth: bodyToApi?.cancelOrdAuth,
      cancelOrdAuthEmployees: bodyToApi?.cancelOrdAuthEmployees,
      addDiscountAuth: bodyToApi?.addDiscountAuth,
      addDiscountAuthEmployees: bodyToApi?.addDiscountAuthEmployees
    });
    console.log('📦 Full bodyToApi:', bodyToApi);
    console.log('🔍 Frontend - branchPosConfigurations.iaPhysicalClosingManual:', branchPosConfigurations?.iaPhysicalClosingManual);
    editBranchSettingsUserAPICall(
      bodyToApi,
      setSnackBarStates,
      snackBarStates
      )
    // Refresh Redux with latest settings after save
    setTimeout(() => {
      console.log('🔄 Refreshing Redux after save...');
      // Use _id from branchSettingsView instead of userId
      if (branchSettingsView?._id) {
        branchSettingsSingleView({ _id: branchSettingsView._id });
      }
    }, 500);
  }
  const defaultTaxChange = (e, newValue) => {
    const addedItems = newValue.filter(item => !formValues.defaultTax.some(obj => obj?._id === item?._id));
    const removedItems = formValues.defaultTax.filter(item => !newValue.some(obj => obj?._id === item?._id));

    if (addedItems.length > 0 || removedItems.length > 0) {
        const updatedDefaultTax = newValue.filter(item => !removedItems.includes(item));
        setFormValues({ ...formValues, defaultTax: updatedDefaultTax });
    }
};

  useEffect(() => {
    if (branchSettingsView !== undefined) {
       setWhatsappEnable(branchSettingsView?.enableWhatsApp || false);
      setSequenceTable(branchSettingsView?.sequences?.map((r, i) => {
        return {
          ...r
        }
      }))
      setFormValues({
        ...formValues,
        branch: filterObjFromList("_id", allBranchesList, "branchId", branchSettingsView),
        location: filterObjFromList("_id", wareHouseLocationList, "locationId", branchSettingsView),
        priceList: filterObjFromList("_id", priceListData, "priceList", branchSettingsView),
        defaultTax: branchSettingsView?.defaultTax,
        termsAndCondition: branchSettingsView?.termsAndCondition
      })
      setPaymentTypeTable(branchSettingsView?.paymentTypes?.map((r, i) => {
        return {
          ...r
        }
      }))
    }
  }, [branchSettingsView, allBranchesList, wareHouseLocationList])

  useEffect(() => {
    // viewBranchSettingsUserAPICall({ branchId:loginResponse?.data?.branchId})
    vieWareHouseLocationAPICall()
    journalListApiCall()
    getAllTaxSettingsListAPICall();
    // getPriceListApi()
    branchSettingsSingleView({ _id: singleRowId })
    categoryListAPICall();

  }, [])


  useEffect(()=>{
    if(formValues?.defaultTax.length===1){
      let inclusive=formValues?.defaultTax[0].includedPrice
      setTaxFileteredList(allTaxListTypeSales?.filter((obj)=>obj.includedPrice === inclusive))
    }else if(formValues?.defaultTax.length===0){
      setTaxFileteredList(allTaxListTypeSales)
    }
  },[formValues?.defaultTax])
  return (
    <div className="global-page-parent-container">
      <div  className="new-global-white-bg-container">
        <div className="new-global-white-bg-icon-container">
          <div className="new-global-white-bg-icon-container-left">
          <Tooltip title="Back" onClick={backButtonFn}>
              <IconButton>
                <i class="bi bi-chevron-left"></i>
              </IconButton>
            </Tooltip>
              <Tooltip title="Save">
                <IconButton
                  onClick={branchSettingsEditFunction}
                >
                <i class="bi bi-floppy"></i>
                {/* <i class="bi bi-check2-square edit-icon"></i> */}
                </IconButton>
              </Tooltip>
       
           
        
         
        
           

          
          </div>
        </div>
        <hr className="global-hr" />
        <div className="new-global-input-container" >
          <div className="new-global-single-input" >
                {/* <TextField 
              id="outlined-basic" 
              label="Branch*" 
              variant="outlined" 
              type="text" focused 
              value={formValues?.branch}
              
              /> */}
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                   options={allBranchesList||[]}
              getOptionLabel={(option) => `${option?.storeCode || ''}-${option?.branchName || ''}`}
              isOptionEqualToValue={(option, value) => option?._id === value?._id}
                  sx={{ width: 300 }}
                  renderInput={(params) => (
                    <TextField {...params} label="Branch*" focused />
                  )}
                  value={formValues?.branch}
                  onChange={(e,newValue)=>setFormValues({...formValues,branch:newValue})}
                  disabled
                 />

            <p className="doc-validation-alert"></p>
          </div>
          <div className="new-global-single-input" >
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={locTypeInternal||[]}
              getOptionLabel={(option) => option?.name || ''}
              isOptionEqualToValue={(option, value) => option?._id === value?._id}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Location*" focused />
              )}
              value={formValues?.location}
              onChange={(e,newValue)=>setFormValues({...formValues,location:newValue})}
             />
            <p className="doc-validation-alert"></p>
          </div>
         
          <div className="new-global-single-input auto-complete-new" >
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={priceListData||[]}
              getOptionLabel={(option) => option?.name || ''}
              isOptionEqualToValue={(option, value) => option?._id === value?._id}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Price List*" focused />
              )}
              value={formValues?.priceList}
              onChange={(e,newValue)=>setFormValues({...formValues,priceList:newValue})}
             />
            <p className="doc-validation-alert"></p>
          </div>
          <div className="new-global-single-input auto-complete-new">
            <Autocomplete
              multiple
              disablePortal
              id="combo-box-demo"
              options={taxFilteredList||[]}
              getOptionLabel={(option) => option?.taxName || ''}
              isOptionEqualToValue={(option, value) => option?._id === value?._id}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Default Tax*" focused />
              )}
              value={formValues?.defaultTax}
              onChange={defaultTaxChange}
             />
            <p className="doc-validation-alert"></p>
           </div>
           
        </div>
        <div className="new-global-single-input auto-complete-new">
  <TextField
    // multiline
    minRows={4}
    label="Terms and Conditions"
    placeholder="Enter terms and conditions..."
    fullWidth
    focused
    value={formValues?.termsAndCondition || ""}
    onChange={(e) =>
      setFormValues({ ...formValues, termsAndCondition: e.target.value })
    }
    // disabled={isEdit}
  />
  <p className="doc-validation-alert"></p>


</div>
  </div>
        <div className='new-global-white-bg-container'>
          <h4 style={{margin:"0"}}>Sequence</h4>
            {
              sequenseTable?.map((r,i)=>(
                <div key={r?._id || r?.sequenceName || i}>
                  <h5 style={{margin:"1% 2%"}}>{r?.sequenceName}</h5>
                 <div style={{margin:"0% 1%"}} className="new-global-input-container">
                   <div className='new-global-single-input'>
                        <TextField 
                         id="outlined-basic" 
                         label="Prefix*" 
                         variant="outlined" 
                         type="text" focused 
                        //  disabled={r?.editable===false}
                         value={r?.prefix}
                         onChange={sequenceChange(i,"prefix")}

                         />
                  </div>
                  <div className='new-global-single-input'>
                        <TextField 
                         id="outlined-basic" 
                         label="Sequence Size*" 
                         variant="outlined" 
                         type="text" focused 
                        //  disabled={r?.editable===false}
                         value={r?.sequenceSize}
                         onChange={sequenceChange(i,"sequenceSize")}
                         />
                  </div>
                  <div className='new-global-single-input'>
                        <TextField 
                         id="outlined-basic" 
                         label="Next No*" 
                         variant="outlined" 
                         type="text" focused 
                        //  disabled={r?.editable===false}
                         value={r?.nextNumber}
                         onChange={sequenceChange(i,"nextNumber")}
                         />
                  </div>
                  <div className='new-global-single-input'>
                        <TextField 
                         id="outlined-basic" 
                         label="Sequence*" 
                         variant="outlined" 
                        //  disabled={r?.editable===false}
                         type="text" focused 
                         value={r?.SN}
                         />
                  </div>
            </div> 
            </div>
              ))
            }
             
           
        </div>

        <PosBranchConfigurations 
        onWhatsAppConfig={setWhatsAppConfig}
        onWhatsAppEnableChange={setWhatsappEnable}
        />
        <div className='new-global-white-bg-container'>
        <div className="new-global-table-container">
           <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",width:"fit-content",marginBottom:"12px",minWidth:"500px"}}>
            <div className="new-global-single-input auto-complete-new" style={{width:"43%"}}>
         
               <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={types||[]}
              getOptionLabel={(option) => option?.value}
              isOptionEqualToValue={(option, value) => option?.value === value?.value}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Type*" focused />
              )}
              value={formValues?.type}
              onChange={(e,newValue)=>{
                                      setFormValues({...formValues,type:newValue,journal:null})
                                      setValidationAlert({})
                                    }}

             />
            <p className="doc-validation-alert">{validationAlert?.type}</p>
            </div>
            <div className="new-global-single-input auto-complete-new" style={{width:"43%"}}>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={
                formValues?.type?.value==="cash"?
                typeCashJournalList
                :formValues?.type===null?
                []
                :typeBankJournalList
                ||[]}
              getOptionLabel={(option) => option?.journalName || ''}
              isOptionEqualToValue={(option, value) => option?._id === value?._id}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Journal*" focused />
              )}
              value={formValues?.journal}
              onChange={(e,newValue)=>{
                                        setFormValues({...formValues,journal:newValue}) 
                                        setValidationAlert({})
                                      }}

             /> 
             <p className="doc-validation-alert">{validationAlert?.journal}</p>
            </div> 

            {
              formValues?.type?.value==="upi" &&
              <>
              <div className="new-global-single-input auto-complete-new" style={{ width: "43%" }}>
                  <Autocomplete
                    options={upiProviders}
                    getOptionLabel={(option) => option?.label || ""}
                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="UPI Provider*"
                        variant="outlined"
                        focused
                      />
                    )}
                    value={formValues?.upiProvider}
                    onChange={(e, value) => {
                      setFormValues({ ...formValues, upiProvider: value })
                      setValidationAlert({})
                    }}
                  />
                <p className="doc-validation-alert">{validationAlert?.upiProvider}</p>
              </div>
              <div className="new-global-single-input auto-complete-new textfield-input" style={{ width: "43%" }}>
                  <TextField
                    id="outlined-basic"
                    label="UPI ID*"
                    variant="outlined"
                    type="text"
                    focused
                    value={formValues?.upiId}
                    onChange={(e) => {
                      setFormValues({ ...formValues, upiId: e.target.value })
                      setValidationAlert({})
                    }}
                  />
                <p className="doc-validation-alert">{validationAlert?.upiId}</p>
              </div> 
              <div className="new-global-single-input auto-complete-new textfield-input" style={{ width: "43%" }}>
                  <TextField
                    id="outlined-basic"
                    label="Banking name*"
                    variant="outlined"
                    type="text"
                    focused
                    value={formValues?.bankingName}
                    onChange={(e) => {
                      setFormValues({ ...formValues, bankingName: e.target.value })
                      setValidationAlert({})
                    }}
                  />
                <p className="doc-validation-alert">{validationAlert?.journal}</p>
              </div>

              {/* UPI API Configuration - For auto-verification */}
              <div className='pos-settings-checkbox-container' style={{ width: "43%", marginTop: "8px" }}>
                <input
                  type="checkbox"
                  id="upiApiEnabled"
                  checked={formValues?.upiApiEnabled}
                  onChange={(e) => {
                    setFormValues({ ...formValues, upiApiEnabled: e.target.checked })
                  }}
                />
                <label htmlFor="upiApiEnabled">Enable Auto-Verification (API)</label>
                <Tooltip title="Enable this to automatically detect payment success via provider API. Requires merchant account with the UPI provider.">
                  <span style={{ marginLeft: '5px', cursor: 'help', color: '#666' }}>ℹ️</span>
                </Tooltip>
              </div>
              
              {formValues?.upiApiEnabled && (
                <>
                <div style={{ width: "100%", padding: "10px", backgroundColor: "#f5f5f5", borderRadius: "8px", marginBottom: "10px" }}>
                  <p style={{ fontSize: "12px", color: "#666", margin: 0 }}>
                    📌 Configure your {formValues?.upiProvider?.label || 'UPI'} Business API credentials for automatic payment verification.
                    <br/>
                    Webhook URL: <code style={{ backgroundColor: "#e0e0e0", padding: "2px 5px", borderRadius: "3px" }}>
                      {window.location.origin}/api/upi-payment/webhook/{formValues?.upiProvider?.value || 'provider'}
                    </code>
                  </p>
                </div>
                <div className="new-global-single-input auto-complete-new textfield-input" style={{ width: "43%" }}>
                  <TextField
                    label="Merchant ID*"
                    variant="outlined"
                    type="text"
                    focused
                    value={formValues?.upiApiConfig?.merchantId || ""}
                    onChange={(e) => {
                      setFormValues({ 
                        ...formValues, 
                        upiApiConfig: {...(formValues.upiApiConfig || {}), merchantId: e.target.value}
                      })
                    }}
                  />
                </div>
                <div className="new-global-single-input auto-complete-new textfield-input" style={{ width: "43%" }}>
                  <TextField
                    label="API Key*"
                    variant="outlined"
                    type="password"
                    focused
                    value={formValues?.upiApiConfig?.apiKey || ""}
                    onChange={(e) => {
                      setFormValues({ 
                        ...formValues, 
                        upiApiConfig: {...(formValues.upiApiConfig || {}), apiKey: e.target.value}
                      })
                    }}
                  />
                </div>
                <div className="new-global-single-input auto-complete-new textfield-input" style={{ width: "43%" }}>
                  <TextField
                    label="API Secret"
                    variant="outlined"
                    type="password"
                    focused
                    value={formValues?.upiApiConfig?.apiSecret || ""}
                    onChange={(e) => {
                      setFormValues({ 
                        ...formValues, 
                        upiApiConfig: {...(formValues.upiApiConfig || {}), apiSecret: e.target.value}
                      })
                    }}
                  />
                </div>
                <div className="new-global-single-input auto-complete-new textfield-input" style={{ width: "43%" }}>
                  <TextField
                    label="API URL (Optional)"
                    variant="outlined"
                    type="text"
                    focused
                    placeholder="Leave empty for default"
                    value={formValues?.upiApiConfig?.apiUrl || ""}
                    onChange={(e) => {
                      setFormValues({ 
                        ...formValues, 
                        upiApiConfig: {...(formValues.upiApiConfig || {}), apiUrl: e.target.value}
                      })
                    }}
                  />
                </div>
                </>
              )}
              </>
            }
            {
              formValues?.type?.value==="card" &&
              <>
              <div className='pos-settings-checkbox-container' style={{ width: "43%", marginTop: "8px" }}>
                <input
                  type="checkbox"
                  id="posMachineEnabled"
                  checked={formValues?.posMachineEnabled}
                  onChange={(e) => {
                    setFormValues({ ...formValues, posMachineEnabled: e.target.checked, posMachineProvider: null })
                  }}
                />
                <label htmlFor="posMachineEnabled">Enable POS Machine</label>
              </div>
              {formValues?.posMachineEnabled && (
                <>
                <div className="new-global-single-input auto-complete-new" style={{ width: "43%" }}>
                  <Autocomplete
                    options={posMachineProviders}
                    getOptionLabel={(option) => option?.label || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="POS Machine Provider*"
                        variant="outlined"
                        focused
                      />
                    )}
                    value={formValues?.posMachineProvider}
                    onChange={(e, value) => {
                      setFormValues({ ...formValues, posMachineProvider: value })
                      setValidationAlert({})
                    }}
                  />
                  <p className="doc-validation-alert">{validationAlert?.posMachineProvider}</p>
                </div>
                
                {/* API Configuration Fields */}
                <div className="new-global-single-input auto-complete-new textfield-input" style={{ width: "43%" }}>
                  <TextField
                    label="Merchant ID*"
                    variant="outlined"
                    type="text"
                    focused
                    value={formValues?.posMachineConfig?.merchantId}
                    onChange={(e) => {
                      setFormValues({ 
                        ...formValues, 
                        posMachineConfig: {...formValues.posMachineConfig, merchantId: e.target.value}
                      })
                    }}
                  />
                </div>
                <div className="new-global-single-input auto-complete-new textfield-input" style={{ width: "43%" }}>
                  <TextField
                    label="Terminal ID"
                    variant="outlined"
                    type="text"
                    focused
                    value={formValues?.posMachineConfig?.terminalId}
                    onChange={(e) => {
                      setFormValues({ 
                        ...formValues, 
                        posMachineConfig: {...formValues.posMachineConfig, terminalId: e.target.value}
                      })
                    }}
                  />
                </div>
                <div className="new-global-single-input auto-complete-new textfield-input" style={{ width: "43%" }}>
                  <TextField
                    label="API Key*"
                    variant="outlined"
                    type="password"
                    focused
                    value={formValues?.posMachineConfig?.apiKey}
                    onChange={(e) => {
                      setFormValues({ 
                        ...formValues, 
                        posMachineConfig: {...formValues.posMachineConfig, apiKey: e.target.value}
                      })
                    }}
                  />
                </div>
                <div className="new-global-single-input auto-complete-new textfield-input" style={{ width: "43%" }}>
                  <TextField
                    label="API Secret"
                    variant="outlined"
                    type="password"
                    focused
                    value={formValues?.posMachineConfig?.apiSecret}
                    onChange={(e) => {
                      setFormValues({ 
                        ...formValues, 
                        posMachineConfig: {...formValues.posMachineConfig, apiSecret: e.target.value}
                      })
                    }}
                  />
                </div>
                <div className="new-global-single-input auto-complete-new textfield-input" style={{ width: "43%" }}>
                  <TextField
                    label="API URL"
                    variant="outlined"
                    type="text"
                    focused
                    placeholder="https://api.pinelabs.com/v1/payment"
                    value={formValues?.posMachineConfig?.apiUrl}
                    onChange={(e) => {
                      setFormValues({ 
                        ...formValues, 
                        posMachineConfig: {...formValues.posMachineConfig, apiUrl: e.target.value}
                      })
                    }}
                  />
                </div>
                </>
              )}
              </>
            }
            <button 
             onClick={plusButtonFn}
             style={{
                backgroundColor:"#08b908",
                border:"none",
                width:"30px",
                height:"30px",
                borderRadius:"4px",
                color:"#fff",
                fontSize:'1.3rem',
                cursor:"pointer"
                }}>
            +
            </button> 
          </div>  
         
          <table>
            <thead>
              <tr>
                <th>Type</th>
                <th>Journal</th>
              </tr>
            </thead>
            <tbody>
               {
                paymentTypeTable?.length !==0 ? paymentTypeTable?.map((r,i)=>(
                  <tr key={i} onClick={tableSingleEdit(r,i)}>
                     <td>
                       {r?.type}
                       {r?.upiId ? ` - ${r?.upiId}` : ''}
                       {r?.upiApiEnabled ? ' 🔄' : ''}
                       {r?.posMachineEnabled && r?.posMachineProvider ? ` - ${posMachineProviders.find(p => p.value === r.posMachineProvider)?.label || r.posMachineProvider}` : ''}
                     </td>
                     <td>{r?.journalName}</td>
                  </tr>
                ))
                :
                <tr>
                  <td colSpan={2}>No Data</td>
                </tr>
               }
                
           
            </tbody>
          </table>
        </div>
        </div>

      {/* <div className='new-global-white-bg-container'>
        <div style={{ maxWidth: 500, margin: "auto", padding: 20 }}>
          <h2>WhatsApp Web Linking</h2>
          <LinkDeviceForm setUserId={setUserId} setQrCode={setQrCode} />
          {qrCode && <QrCodeDisplay qrCode={qrCode} />}
          {userId && qrCode && <SendMessageForm userId={userId} />}
        </div>
      </div> */}
      
        <SuccessSnackbar
        open={snackBarStates.success}
        handleClose={closeSnackbar}
        message={snackBarStates.message}
      />

      <ErrorSnackbar
        open={snackBarStates.error}
        handleClose={closeSnackbar}
        message={snackBarStates.message}
      />
    </div>
  )
}
